import { render, staticRenderFns } from "./StepAccordionShell.vue?vue&type=template&id=d7fdaa5a&scoped=true&"
import script from "./StepAccordionShell.vue?vue&type=script&lang=ts&"
export * from "./StepAccordionShell.vue?vue&type=script&lang=ts&"
import style0 from "./StepAccordionShell.vue?vue&type=style&index=0&id=d7fdaa5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7fdaa5a",
  null
  
)

export default component.exports